import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between items-center mb-8" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl font-black" }, " Forms ")
], -1)
const _hoisted_3 = {
  key: 0,
  class: "border-b border-gray-200 mb-10"
}
const _hoisted_4 = {
  class: "-mb-px flex space-x-8",
  "aria-label": "Tabs"
}
const _hoisted_5 = ["aria-current", "onClick"]
const _hoisted_6 = {
  key: 1,
  class: "shadow overflow-hidden border-b border-gray-200 sm:rounded-lg"
}
const _hoisted_7 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-gray-50" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
    }, " Form "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
    }, " Status "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
    }, " Progress ")
  ])
], -1)
const _hoisted_9 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-900" }
const _hoisted_12 = { class: "text-sm font-medium text-brand" }
const _hoisted_13 = { class: "text-sm text-gray-500" }
const _hoisted_14 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-center" }
const _hoisted_15 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500" }
const _hoisted_16 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatusBadge = _resolveComponent("StatusBadge")!

  return (_ctx.forms)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        (_ctx.forms.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("nav", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
                  return (_openBlock(), _createElementBlock("a", {
                    key: tab.name,
                    class: _normalizeClass([tab.current ? 'border-brand text-brand' : 'border-transparent cursor-pointer text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm']),
                    "aria-current": tab.current ? 'page' : undefined,
                    onClick: ($event: any) => (_ctx.onChangeTab(tab.path))
                  }, _toDisplayString(tab.name), 11, _hoisted_5))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.forms.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("table", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("tbody", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredForms, (form, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: index,
                      class: _normalizeClass(['hover:bg-gray-50 cursor-pointer']),
                      onClick: ($event: any) => (_ctx.onRowSelection(form.id))
                    }, [
                      _createElementVNode("td", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, _toDisplayString(form.data.name), 1),
                        _createElementVNode("div", _hoisted_13, _toDisplayString(form.data.description), 1)
                      ]),
                      _createElementVNode("td", _hoisted_14, [
                        _createVNode(_component_StatusBadge, {
                          status: form.data.status
                        }, null, 8, ["status"])
                      ]),
                      _createElementVNode("td", _hoisted_15, _toDisplayString(form.data.progress) + "% ", 1)
                    ], 8, _hoisted_10))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_16, " Loading Forms... "))
}